// /src/pages/OpenSourcePage.jsx
import React from 'react';
import { Github, ExternalLink } from 'lucide-react';
import { cardCls, headingCls, bodyText, mutedText, ctaPrimary, pageHeading, sectionLabel, pageWrap, sectionInner } from '../components/styles';
import { Chip } from '../components/Chip';
import { projects } from '../data/opensource';

export default function OpenSourcePage() {
  return (
    <div className={pageWrap}>
      {/* Hero */}
      <section className="py-12" style={{ background: 'var(--bg)' }}>
        <div className={sectionInner}>
          <div className="max-w-6xl animate-stagger">
            <h1 className={`${pageHeading} mb-4`}><span className="opacity-50">$</span> open-source</h1>
            <p className={`text-xl ${mutedText} max-w-3xl`}>
              Tools and projects I've built and released publicly. Everything here is free to use, fork, and modify.
            </p>
          </div>
        </div>
      </section>

      <hr className="section-rule" />

      {/* Project grid */}
      <section className="py-10" style={{ background: 'var(--bg2)' }}>
        <div className={sectionInner}>
          <div className="grid md:grid-cols-2 gap-6 max-w-6xl animate-stagger">
            {projects.map((project) => (
              <div key={project.name} className={`glow-card ${cardCls} p-8 flex flex-col`}>
                <div className="flex justify-between items-start mb-3">
                  <h3 className={`text-2xl ${headingCls}`}>{project.name}</h3>
                  <span className="font-mono text-xs font-semibold px-3 py-1 rounded-lg border border-[color:var(--border)] bg-[var(--bg2)]"
                    style={{ color: '#a7df6a' }}
                  >
                    {project.category.toUpperCase()}
                  </span>
                </div>

                <p className={`${bodyText} leading-relaxed mb-4 flex-1`}>{project.description}</p>

                <div className="flex flex-wrap gap-2 mb-6">
                  {project.tech.map((t) => (
                    <Chip key={t}>{t}</Chip>
                  ))}
                </div>

                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${ctaPrimary} w-full justify-center text-base`}
                >
                  <Github size={20} /> View on GitHub <ExternalLink size={16} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <hr className="section-rule" />

      {/* CTA */}
      <section className="py-10" style={{ background: 'var(--bg)' }}>
        <div className={sectionInner}>
          <div className="max-w-6xl">
            <h2 className={`${sectionLabel} mb-6`}>{'// more'}</h2>
            <div
              className="rounded-lg p-8 border border-[color:var(--border)]"
              style={{ background: 'linear-gradient(135deg, rgba(10,191,218,0.08), rgba(193,232,111,0.08))' }}
            >
              <h3 className={`text-2xl ${headingCls} mb-3`}>More on GitHub</h3>
              <p className={`${mutedText} mb-6`}>
                These are the highlights. Check my GitHub for the full collection.
              </p>
              <a
                href="https://github.com/hackingpain"
                target="_blank"
                rel="noopener noreferrer"
                className={ctaPrimary}
              >
                <Github size={20} /> github.com/hackingpain
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
